module.exports = __webpack_public_path__ + "img/vodafone.dc584e90.svg";